module.exports = __webpack_public_path__ + "static/media/29DUNON1.b00de24b.jpg";